import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ActionRequestDetails } from "../_globalTypes/index.js";
import { ProductReviewMobileWarning } from "./productReviewMobileWarning.js";
import { PageHeader } from "../reusableComponents/PageHeader/index.js";
import { Section } from "../reusableComponents/Section/index.js";
import TabSection from "../reusableComponents/TabSection/index.js";
import ActionRequests from "../actionRequests/index.js";
import {
  ProductReviewContainer,
  ProductReviewContent,
  ProductReviewIframe,
} from "./productReviewDetailStyles.js";

const screenSize = document.documentElement.clientWidth;

const THD_SITE = [
  { id: 0, site: "HomeDepot.com", siteName: 'HomeDepot' },
  { id: 1, site: "Instore Design Builder", siteName: 'DesignBuilder' },
];
const HomeDepotSiteId = 11;

const ProductReviewDetails = ({ draftInfo }) => {
  const { productName, previews, siteId } = draftInfo;
  const [activeSite, setActiveSite] = useState(previews[0].siteName);
  const [showTabbedSection, setShowTabbedSection] = useState(false);

  useEffect(() => {
    if(siteId === HomeDepotSiteId && screenSize > 768) {
      setShowTabbedSection(true);
    } else {
      setShowTabbedSection(false);
    }
    setActiveSite(previews[0].siteName);
  }, [draftInfo, siteId])

  const handleTabClick = (siteName) => {
    const newActiveSite = THD_SITE.filter(item => item.siteName === siteName)[0];
    setActiveSite(newActiveSite.siteName);
  };

  const previewUriWithToken = () => {
    const vendorToken = window.localStorage.getItem('vpToken');
    if(activeSite !== 'DesignBuilder'){
     let hdUri= previews[0].previewUrl;
     if(vendorToken.length > 0) {
        return  hdUri + ( hdUri.includes("?") ? `&` : `?` ) + `vendorToken=${vendorToken}`;
      }
      return hdUri;
    } else {
      let uri = previews[1].previewUrl;
      
      if(vendorToken.length > 0) {
        return uri + `?vendorToken=${vendorToken}`;
      }

      return uri;
    }
  }


  return (
    <ProductReviewContainer>
      <PageHeader title={productName} siteId={siteId} />
      <ProductReviewContent>
        <ActionRequests
          actions={[
            {
              ...draftInfo,
              siteName: activeSite,
              siteId,
            },
          ]}
          isBeingReviewed={true}
        />
        <TabSection
          tabHeaders={THD_SITE}
          showTabs={showTabbedSection}
          activeSite={activeSite}
          handleTabClick={handleTabClick}
        >
          <Section title="Configuration Preview" style={{ margin: "0" }}>
            {screenSize <= 768 ? <ProductReviewMobileWarning /> : null}
            <ProductReviewIframe>
              <iframe
                src={ previewUriWithToken() }
                height="600px"
                width="100%"
              />
            </ProductReviewIframe>
          </Section>
        </TabSection>
      </ProductReviewContent>
    </ProductReviewContainer>
  );
};

ProductReviewDetails.propTypes = {
  draftInfo: PropTypes.shape(ActionRequestDetails),
};

export default ProductReviewDetails;
